import { render } from "./RateLimitedButton.vue?vue&type=template&id=a60a78ea"
import script from "./RateLimitedButton.vue?vue&type=script&lang=js"
export * from "./RateLimitedButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__